import * as d3 from 'd3'
import withResponsive from '../hoc/withResponsive'

export default withResponsive({
  name: 'chart',

  componentDidMount () {
    // set the dimensions and margins of the graph
    const width = 650
    const height = 450
    const margin = 140

    // The radius of the pieplot is half the width or half the height (smallest one). I subtract a bit of margin.
    const radius = Math.min(width, height) / 2 - margin

    const svg = d3
      .select(this.el)
      .append('svg')
      .attr('width', width)
      .attr('height', height)
      .append('g')
      .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')')

    const data = this.props.datas

    const dataValues = Object.values(this.props.datas)
    let colors = ['#04b6d5', '#018b77', '#92c470', '#0058a2']
    // let widthLabels = [70, 105, 135, 200] // multiple lines
    let widthLabels = [100, 140, 165, 230]

    colors = colors.filter((item, i) => dataValues[i] !== 0)
    widthLabels = widthLabels.filter((item, i) => dataValues[i] !== 0)

    Object.entries(data).forEach((item) => {
      if (item[1] === 0) {
        delete data[item[0]]
      }
    })

    const pie = d3
      .pie()
      .sort(null) // Do not sort group by size
      .value(function (d) {
        return d[1]
      })

    const dataReady = pie(Object.entries(data))

    // The arc generator
    const arc = d3
      .arc()
      .innerRadius(radius * 0.59) // This is the size of the donut hole
      .outerRadius(radius * 0.8)

    // Another arc that won't be drawn. Just for labels positioning
    const outerArc = d3
      .arc()
      .innerRadius(radius * 0.9)
      .outerRadius(radius * 0.9)

    // Build the pie chart: Basically, each part of the pie is a path that we build using the arc function.
    const slices = svg.selectAll('allSlices').data(dataReady).enter()

    slices
      .append('path')
      .attr('d', arc)
      .attr('fill', function (d, i) {
        return colors[i]
      })

    slices
      .append('circle')
      .style('fill', function (d, i) {
        return colors[i]
      })
      .attr('r', 9)
      .attr('cx', function (d) {
        return (radius * 0.8 - 9) * Math.cos(d.endAngle - Math.PI / 2)
      })
      .attr('cy', function (d) {
        return (radius * 0.8 - 9) * Math.sin(d.endAngle - Math.PI / 2)
      })

    const polylines = svg.selectAll('allPolylines').data(dataReady).enter()

    // draw line for labels
    polylines
      .append('polyline')
      .attr('stroke', '#979797')
      .style('fill', 'none')
      .attr('stroke-width', 1)
      .attr('points', function (d, i) {
        const posA = arc.centroid(d) // line insertion in the slice
        const posB = outerArc.centroid(d) // line break: we use the other arc generator that has been built only for that
        const posC = outerArc.centroid(d) // Label position = almost the same as posB
        const midangle = d.startAngle + (d.endAngle - d.startAngle) / 2 // we need the angle to see if the X position will be at the extreme right or extreme left
        posC[0] = radius * 0.95 * (midangle < Math.PI ? 1 : -1) // multiply by 1 or -1 to put it on the right or on the left

        if (midangle < Math.PI) {
          posC[0] += widthLabels[i]
        } else {
          posC[0] -= widthLabels[i]
        }

        return [posA, posB, posC]
      })

    // draw circle for each label
    polylines
      .append('circle')
      .style('fill', '#979797')
      .attr('r', 4)
      .attr('cx', function (d) {
        return arc.centroid(d)[0]
      })
      .attr('cy', function (d) {
        return arc.centroid(d)[1]
      })

    // add text foreach label
    svg
      .selectAll('allLabels')
      .data(dataReady)
      .enter()
      .append('text')
      .text(function (d) {
        return d.data[0]
      })
      .attr('fill', function (d, i) {
        return colors[i]
      })
      .attr('transform', function (d, i) {
        const pos = outerArc.centroid(d)
        const midangle = d.startAngle + (d.endAngle - d.startAngle) / 2
        pos[0] = radius * 0.99 * (midangle < Math.PI ? 1 : -1)
        pos[1] = pos[1] - 5 // >> -25 if multiples lines

        if (midangle >= Math.PI) {
          pos[0] -= widthLabels[i]
        }

        return 'translate(' + pos + ')'
      })
      .style('text-anchor', 'start')
      // .append('tspan') /// comment from here if one line
      // .attr('x', -2)
      // .attr('dy', '1.1em')
      // .text(function (d) {
      //   return d.data[0].split('%')[1]
      // })
  },
})
